import React from 'react';
import Layout from "@/Shared/Layout";
import {InertiaLink, usePage} from "@inertiajs/inertia-react";
import Pagination from "@/Shared/Pagination";
import PaginateCount from "@/Shared/PaginateCount";
import TableHeadSort from "@/Shared/TableHeadSort";
import dayjs from "dayjs";
import PublicCouponActionBtns from "@/Pages/Coupons/Assets/PublicCouponActionBtns";
import PublicCouponsSearchFilter from "@/Pages/Coupons/Assets/PublicCouponsSearchFilter";
import useCheckbox from "@/Hooks/useCheckbox";
import PublicCouponBottomPanel from "@/Pages/Coupons/Assets/PublicCouponBottomPanel";

const Index = () => {
  const {coupons, discount_types} = usePage().props;
  const {
    data,
    meta: {links}
  } = coupons;
  console.log('coupons', coupons);
  const {
    checked,
    checkboxesParent,
    handleCheck,
    handleCheckAll,
    parentCheckbox
  } = useCheckbox(data, 'coupon_id')

  return (
    <div>
      <div className='mb-3 flex justify-between items-center	'>
        <h1 className="text-3xl font-bold">Published Coupons</h1>
      </div>

      <div className="flex items-center justify-between mb-6">
        <PublicCouponsSearchFilter discountTypes={discount_types}/>

        <PaginateCount/>
      </div>

      <div className="overflow-x-auto bg-white rounded shadow">
        <table className="w-full table-auto text-sm">
          <thead>
          <tr className="font-bold text-left">
            <th className="px-1 pt-5 pb-4 w-1">_</th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-1' sortName='id' title='ID'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='code' title='Code'/>
            <th className="px-3 pt-5 pb-4 w-1.5"></th>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='description' title='Description'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='expire_date' title='Expiration'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='start_date' title='Date Entered'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4' sortName='merchant_name' title='Merchant Name'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='ysnTested' title='Tested'/>
            <TableHeadSort customClassName='px-1 pt-5 pb-4 w-3' sortName='showonline' title='Show online'/>
            <th className="px-1 pt-5 pb-4">Actions</th>
          </tr>
          </thead>
          <PublicCouponBottomPanel parentCheckbox={parentCheckbox} checked={checked} handleCheckAll={handleCheckAll}/>
          <tbody ref={checkboxesParent}>
          {data.map(({
                       code,
                       coupon_id,
                       meta_description,
                       expire_date_iso,
                       start_date_iso,
                       merchant_name,
                       ysnSiteLink,
                       hot_coupon,
                       ysnTested,
                       showonline,
                       categories
                     }) => (
            <tr
              key={coupon_id}
              className="hover:bg-gray-100 focus-within:bg-gray-100"
            >
              <td className="border-t">
                <div className="flex items-center px-1 py-4 focus:text-indigo-700 focus:outline-none">
                  <input
                    type="checkbox"
                    name={coupon_id}
                    onChange={handleCheck} />
                </div>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="1"
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                  href={route('public.coupons.edit', coupon_id)}
                >
                  {coupon_id}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {code}
                </InertiaLink>
              </td>
              <td className="border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 py-4 focus:text-indigo focus:outline-none"
                >
                  {!!ysnSiteLink && <img className='h-6' src='/images/coupon/dollarsign.gif' alt='site link'/>}
                  {!!hot_coupon && <img className='h-4' src='/images/coupon/hotcouponstar.gif' alt='hot coupons'/>}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {meta_description}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {expire_date_iso ? dayjs(expire_date_iso).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {start_date_iso ? dayjs(start_date_iso).format('MM-DD-YYYY HH:MM:ss') : 'Unknown'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none"
                >
                  {merchant_name}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none "
                >
                  {!!ysnTested ? 'Yes' : 'No'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <InertiaLink
                  tabIndex="-1"
                  href={route('public.coupons.edit', coupon_id)}
                  className="flex items-center px-1 focus:outline-none "
                >
                  {!!showonline ? 'Yes' : 'No'}
                </InertiaLink>
              </td>
              <td className="w-px border-t">
                <PublicCouponActionBtns couponCategories={categories} showonline={showonline} id={coupon_id}/>
              </td>
            </tr>
          ))}
          {data.length === 0 && (
            <tr>
              <td className="px-1 py-4 border-t" colSpan="4">
                No coupons found.
              </td>
            </tr>
          )}
          </tbody>
        </table>
      </div>
      <Pagination links={links}/>
    </div>
  );
};
Index.layout = page => <Layout title="Published Coupons" children={page}/>;
export default Index;
